import { css, styled } from 'styled-components';
import { Media } from '../../../../../theme/Media.js';
import { CELL_PADDING_COMPACT, CELL_PADDING_DEFAULT, MOBILE_PADDING } from '../../constants.js';
import { actionCellStyles, checkboxCellStyles, dndCellStyles } from '../../mixins.js';
import { TableCellContentType } from '../../types.js';
export const SubRowsContainer = styled.div `
  grid-column: 1 / -1;
  grid-row: 2;
  display: grid;
  grid-template-columns: subgrid;
  background: ${({ theme }) => theme.colors.grey00_1};

  ${({ $isInteractive }) => $isInteractive &&
    css `
      cursor: pointer;
    `}

  @media ${Media.xsMax} {
    display: block;
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
    -webkit-tap-highlight-color: transparent;
  }
`;
export const SubRowWrapper = styled.div `
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  overflow: clip;
  background: inherit;

  @media ${Media.xsMax} {
    display: block;
  }
`;
export const SubRowContent = styled.div `
  padding: ${({ $compact }) => ($compact ? CELL_PADDING_COMPACT : CELL_PADDING_DEFAULT)};
  grid-column: span ${({ $colSpan }) => $colSpan};

  @media ${Media.xsMax} {
    padding: ${MOBILE_PADDING};
  }
`;
export const SubRowPlaceholder = styled.div `
  @media ${Media.smMin} {
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.DND && dndCellStyles($compact)}
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.CHECKBOX && checkboxCellStyles($compact)}
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.ACTION && actionCellStyles($compact)}
  }

  @media ${Media.xsMax} {
    display: none;
  }
`;
